import {CompositeLayer} from 'deck.gl';
import {TextLayer, ScatterplotLayer} from '@deck.gl/layers';

class GeoJsonNodeLayer extends CompositeLayer { 
  constructor(state) {
    super(state);
  }
  
  renderLayers() {
    //TextLayer.fontAtlasCacheLimit = 10;
    return [
      new ScatterplotLayer(this.props, {
        id: `${this.props.id}-point`,
        data: this.props.data,
        getPosition: this.props.getPosition,
        radiusScale: this.props.radiusScale,
        radiusMinPixels: this.props.getRadiusMinPixels,
        radiusMaxPixels: this.props.getRadiusMaxPixels,
        getFillColor: this.props.getFillColor,
        getRadius: this.props.getRadius,
        getLineColor: [255, 255, 255],
        lineWidthMinPixels: 1,
        lineWidthMaxPixels: 1,
        stroked: true,
        antialiasing:true,
        highlightColor: this.props.getHoverColor,
        highlightLineColor: [0,0,0],
        highlightedObjectIndex: this.props.highlightedObjectIndex,
        //updateTriggers: { // https://deck.gl/docs/api-reference/core/layer#updatetriggers
        //  highlightedObjectIndex:this.props.highlightedObjectIndex
        //},
      }),
      new TextLayer(this.props, {
        id: `${this.props.id}-label`,
        data: this.props.data,
        getPosition: this.props.getPosition,
        getText: this.props.getText,
        getSize: this.props.getTextSize,
        antialiasing:true,
        fontSettings: {
          fontSize:128,
          sdf:false,
          radius:12,
          cutoff:0.3,//0.3, // only applied if sdf is true
          smoothing:0.3//0.1, // only applied if sdf is true
        },
        //fontWeight:"normal",
        //sizeScale:5,
        getColor: this.props.getTextColor,
        fontFamily: this.props.getFontFamily,
        visible: this.props.getTextVisible,
        sizeMinPixels: 2,
        //background:true,
        //backgroundPadding: [5,5,5,5],
        //billboard:false,
        highlightColor: this.props.getHoverTextColor, // https://deck.gl/docs/api-reference/core/layer#updatetriggers
        highlightedObjectIndex: this.props.highlightedObjectIndex,
        //updateTriggers: { // https://deck.gl/docs/api-reference/core/layer#updatetriggers
        //  highlightedObjectIndex:this.props.highlightedObjectIndex
        //},
        getTextAnchor: 'middle',
        getAlignmentBaseline: 'center',
        parameters: {depthTest: false},
        //billboard: false   
      })
    ];
  }
}

GeoJsonNodeLayer.layerName = 'GeoJsonNodeLayer';
GeoJsonNodeLayer.defaultProps = {
  getPosition: x => x.position,
  highlightedObjectIndex: -1,

  radiusScale: 5,
  getRadiusMinPixels: 2,
  getRadiusMaxPixels: 2,

  getFillColor: [255, 0, 0],
  getRadius: 1,
  getHoverColor: [255, 0, 0],

  // Text accessors
  getText: x => x.label,
  getTextSize: 5,
  getTextColor: [0, 0, 0],
  textMinZoom: 10,
  textMaxZoom: 16,
  getTextVisible: true
};

export default GeoJsonNodeLayer;